<isp-dynamic-form
  [doc]="doc"
  [context]="context"
  [isExtformLayout]="true"
  [showBlockingPreloader]="false"
  [templatesConfigs]="templateConfigs"
  [showGeneralErrorInNotification]="false"
  (changeModel)="changeModel.emit($event)"
  (buttonClick)="buttonClick.emit($event)"
  #dynamicForm
>
  <ng-container *ispDynamicFormTemplate="'under-form'">
    <isp-page-social
      *ngIf="socialData"
      [baseDir]="socialData.baseDir"
      [imageLinks]="socialData.imageLinks"
      [socialTitleMessage]="socialData.socialTitleMessage"
    ></isp-page-social>
    <isp-page-register
      *ngIf="registerData"
      [link]="registerData.link"
      [noAccountMessage]="registerData.noAccountMessage"
      [registerOneselfMessage]="registerData.registerOneselfMessage"
    ></isp-page-register>
  </ng-container>

  <ng-container *ispDynamicFormTemplate="'page-documents'">
    <isp-page-documents
      *ngIf="documentsData"
      [documentLinks]="documentsData.links"
    ></isp-page-documents>
  </ng-container>

  <ng-container *ispDynamicFormTemplate="'page-copyright'">
    <isp-page-copyright
      *ngIf="copyrightData"
      [href]="copyrightData.href"
      [text]="copyrightData.text"
    ></isp-page-copyright>
  </ng-container>
</isp-dynamic-form>
